/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type AdminPanelBillingGroupsMembers_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"OrgInvite_viewer">;
    readonly " $refType": "AdminPanelBillingGroupsMembers_viewer";
};
export type AdminPanelBillingGroupsMembers_viewer$data = AdminPanelBillingGroupsMembers_viewer;
export type AdminPanelBillingGroupsMembers_viewer$key = {
    readonly " $data"?: AdminPanelBillingGroupsMembers_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"AdminPanelBillingGroupsMembers_viewer">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminPanelBillingGroupsMembers_viewer",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "OrgInvite_viewer"
        }
    ],
    "type": "Viewer",
    "abstractKey": null
} as any;
(node as any).hash = '039accba65f2ba4cab3687c4c34292fe';
export default node;
